import { createContext } from 'react';
export var SearchStyle;
(function (SearchStyle) {
    SearchStyle["dropdown"] = "dropdown";
    SearchStyle["resultsPage"] = "resultsPage";
})(SearchStyle || (SearchStyle = {}));
// The default {} will never be used as we wrap the App component with this.
export const Context = createContext({});
//# sourceMappingURL=Config.js.map